import React, { useEffect } from 'react';
import { selectLINKtivityAccessAllowed } from '../../../common/subscription/SubscriptionSlice';
import { Breadcrumbs, Typography, Link, Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useSelector } from 'react-redux';
import PageTitle from '../../../common/components/PageTitle';
import PreviewMode from '../PreviewMode';
import NewAndFeaturedList from '../NewAndFeaturedList';
import { LTVLIBHOME } from '../../../routes/CONSTANTS';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

const BackButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(5),
}));

export function LtvLibNewAndFeatured() {
  const LINKtivityAccessAllowed = useSelector(selectLINKtivityAccessAllowed);
  const navigate = useNavigate();

  const handleBackToLibHomeClick = (event) => {
    event.preventDefault();
    navigate(LTVLIBHOME);
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Breadcrumbs
        aria-label='breadcrumb'
        sx={{ paddingBottom: 2 }}
        separator={<ChevronRightIcon />}
      >
        <Link
          underline='hover'
          key='1'
          color='inherit'
          component={RouterLink}
          to={LTVLIBHOME}
        >
          Library Home
        </Link>
        ,
        <Typography key='2' color='primary.main'>
          New & Featured
        </Typography>
      </Breadcrumbs>
      <PageTitle
        title={
          LINKtivityAccessAllowed
            ? 'New & Featured LINKtivities'
            : 'New & Featured LINKtivities - PREVIEW'
        }
      />
      <Typography>
        Click on a LINKtivity® card to view the details about that LINKtivity®
      </Typography>
      <NewAndFeaturedList numItems={99} />
      {!LINKtivityAccessAllowed && <PreviewMode />}
      <BackButton variant='contained' onClick={handleBackToLibHomeClick}>
        <ArrowBackIcon style={{ marginRight: '5' }} />
        Back to Categories
      </BackButton>
    </>
  );
}
